import { IKnmErknmOrganizationTemplateSelectOption } from '../interfaces/IKnmErknmOrganizationTemplateSelectOption';

export const newOrganizationTemplateSelectOption: IKnmErknmOrganizationTemplateSelectOption = {
  id: '',
  label: 'Создать новый',
  value: '',
  inn: undefined,
  ogrn: undefined,
  organizationName: undefined,
  isFiz: undefined,
  isDocumentOrganization: true,
  nkoForeignAgentsRegistryNumber: undefined,
  nkoForeignAgentsRegistryInclusionDate: undefined,
  nkoForeignAgentsRegistryExclusionDate: undefined,
  isNko: undefined,
  subjectType: undefined,
  kpp: undefined,
  smevRequestStatus: undefined,
  rafpNza: undefined,
  isForeignSubjectAgencyNotRegistredInRf: undefined,
  country: undefined,
  locationAddress: undefined,
  workAddress: undefined,
  factualAddress: undefined,
  snils: undefined,
  document: undefined,
  ervkId: undefined,
  isSonko: undefined,
  mspCode: undefined,
  isPresentInItRegistry: undefined,
  itAccreditationResponse: undefined,
  smevItAccreditationRequestStatus: undefined,
  checkSubjectResult: null,
};
